import { render, staticRenderFns } from "./FaceModal.vue?vue&type=template&id=2644c9a7&scoped=true&"
import script from "./FaceModal.vue?vue&type=script&lang=js&"
export * from "./FaceModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2644c9a7",
  null
  
)

export default component.exports